/* eslint-disable react/prop-types */
import React from 'react';
import Copyright from './Copyright';
import '~styles/modules/credits.scss';

const Credits = () => {
  // create columns of <li> elements for the credits well

  const credits = [
    {
      role: 'Reporters',
      name: 'Penelope Overton, Jenna Russell, David Abel',
    },
    {
      role: 'Photographers',
      name: 'Jessica Rinaldi and Brianna Soukup',
    },
    {
      role: 'Editors',
      name: 'Brendan McCarthy, Scott Allen, Mark Morrow, Steve Greenlee, Jason Tuohey',
    },
    {
      role: 'Design',
      name: 'Ryan Huddle, Matt Fulton',
    },
    {
      role: 'Homepage & app',
      name: 'Yiqing Shao, Leah Becerra, Lauren Booker',
    },
    {
      role: 'Developers',
      name: 'Daigo Fujiwara, John Hancock, Vince Dixon, Todd Dukart',
    },
    {
      role: 'Graphics',
      name: 'John Hancock and Vince Dixon',
    },
    {
      role: 'Photo editors',
      name: 'William Greene, Michele McDonald, Leanne Burden Seidel',
    },
    {
      role: 'Video producer and editor',
      name: 'Caitlin Healy',
    },
    {
      role: 'Copy editors',
      name: 'Mary Creane, Michael Bailey, Brian Robitaille',
    },
    {
      role: 'Social media',
      name: 'Christina Prignano, Devin Smith, Maddie Mortell, Katherine Lee',
    },
    {
      role: 'Analytics & engagement',
      name: 'Karla Ovalle',
    },
    {
      role: 'SEO',
      name: 'Cameron Muir',
    },
    {
      role: 'Newsletters',
      name: 'LaDonna LaGuerre, Emma Kelley, Marie Princiotto',
    },
    {
      role: 'Quality assurance',
      name: 'Jackson Pace',
    }];

  const list = credits.map((credit) => {
    const listKey = `${credit.role}-${credit.name}`;
    return (
      <li className="bentonsanscond-n4" key={listKey}>
        <span className="bentonsanscond-n6">
          {credit.role}
          {': '}
        </span>
        {credit.name}
      </li>
    );
  });

  return (
    <div id="credit__well">
      <div id="credits" className="text__well">
        <h6 className="bentonsanscond-n6">Credits</h6>
        <div className="credits__wrapper">
          <ul className="credit-list">{list}</ul>
        </div>
        <Copyright />
      </div>
    </div>
  );
};

export default Credits;
